
import { HeadBar, BccPasswordDialog } from '@/components';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import PaymentInstance from './components/PaymentInstance';
import { PaymentProxy,OrderProxy,HotelProxy } from "@/http/RequestProxy.class";
import utils from "@/utils/utils";
import JSEncrypt from 'jsencrypt';
import hex_md5 from 'md5-hex';
const paymentProxy = new PaymentProxy();
const orderProxy = new OrderProxy();

export default {
name: 'payment',
components: {
PaymentInstance,
HeadBar,
Flexbox,
FlexboxItem,
BccPasswordDialog,
},
data() {
return {
dueAmount: 0,
startDate: '',
endDate: '',

orderInfo: {},
paymentInfo: {},
cardInfo: {},


query: {
payment_mode: 'WAP',
order_id: '',
payment_method: 1,
use_balance: 0, // 是否使用余额
use_bcc: 0,     // 是否使用bcc
bcc_pwd: '',    // bcc支付密码
},

isShowBccPwdDialog: false,    // 显示bcc密码输入框
bccPwdError: false,   // bcc密码是否有误
bccWallet: {},    // bcc相关数据
cardOptions: {},  // 通联支付卡号数据


loading:1,
countdown: {
hours: '',
minutes: '00',
seconds: '00',
},
countdownTimer:null,
isExpired:false,
iconName:null,
regexpArr:[],
fcardNum:'',
cardNum:'',
cardName:'',
fcardDate:'',
securityNum:'',
isModal3DS:false,
isModalOrderDetailShow:false,
isMaskShow:false,
currentScenario: 1,
selectedMethods: [],
check1Disabled: false,
check2Disabled: false,
check3Disabled:false,
isOpen: false,
LAKALAPAY: '',
ALLINPAY: '',
orderDetail: {
currency_code: window.localStorage.getItem('currency_code') || 'CNY',
reservation: {
golf_course_name: ''
}
},
businessCode:'',
order_title:'',
orderAmount: 0,
financeInfo: {
bcc: {
bbc_balance: 0
}
},
payAmount: {
currency_code: '',
due_amount: ''
},
payList:[],
contentHtml:'',
isAgreeMentShow:false
};
},
created() {

this.getCardRegexp();
this.getWalletInfo()
this.getPayList()
this.getAgreement()
},
mounted() {
if (!utils.isWechatBrowser()) {
this.query.payment_method = 2;
}
this.query.order_id = this.$route.query.order_id;

this.setCode();
},
methods: {
/** 获取支付相关的信息 */
getPaymentInfo() {
this.$vux.loading.show();

paymentProxy.getPaymentInfo({ orderId: this.query.order_id })
.then(resp => {
if (resp) {




this.LAKALAPAY = resp.data.foreign_card_rate.lakalapay
this.ALLINPAY = resp.data.foreign_card_rate.allinpay
this.startDate = utils.formatDateWithStamp(Number(resp.data.order_info.booking_start_time) * 1000, true);
this.endDate = utils.formatDateWithStamp(Number(resp.data.order_info.booking_end_time) * 1000, true);
this.orderDetail = {...resp.data.order_info,...resp.data.payment_info,currency_code:resp.data.payment_info.currency_type}
console.log(localStorage.getItem('currency_code'))
if (resp.data.payment_info.currency_type != localStorage.getItem('currency_code')) {
this.check1Disabled = true
this.check2Disabled = true

}
this.orderAmount = Number(resp.data.payment_info.due_amount)
this.order_title = this.truncateString(resp.data.order_info.hotel_name, 20)
this.updateScenario()
this.startCountdown(this.orderDetail.remain_pay_time)
this.loading = 2
}
this.$vux.loading.hide();
});
},

/** 获取bcc相关数据 */
onGetBccData(bccData) {
this.bccWallet = bccData;
},

/** 选择第三方支付方式 */
onGetPayment(paymentType) {
this.query.payment_method = paymentType;
},

/** 使用账户余额&BCC */
onGetBalanceAndBcc(resp) {
resp.useBalance > 0 ? this.query.use_balance = 1 : this.query.use_balance = 0;
resp.useBcc > 0 ? this.query.use_bcc = 1 : this.query.use_bcc = 0;

this.dueAmount = Math.ceil(this.paymentInfo.due_amount - resp.useBalance - resp.useBcc);
},

/** 获取微信支付的code */
setCode() {
let href = window.location.href;

if (href.indexOf('code') > -1) {
let query = href.split('?')[1].split('&')[1];
let codeArr = query.split('=');


if (codeArr[0] == 'code') {
this.query = Object.assign({}, this.query, { code: codeArr[1] });
setTimeout(() => {
this.submitOrder();
}, 2000);
}
}
},

/** 发起支付 */
onSubmitPayment() {

if (this.query.payment_method === 10 && !this.query.extra_param) {
this.encryptAllinParams();
return false;
}


if (+this.query.use_bcc === 1 && !this.bccWallet.is_set_pwd) {
this.$vux.confirm.show({
content: '您还没有设置bcc支付密码！',
confirmText: '前往设置',
cancelText: '取消',
onConfirm() {
window.location.href = `${this.$store.state.WAP_HOST}`;
}
});
return false;
}


if (+this.query.use_bcc === 1 && !this.query.bcc_pwd) {

this.isShowBccPwdDialog = true;
return false;
}

this.$vux.loading.show();
console.log(this.query)

paymentProxy.submitPayment(this.query)
.then(resp => {
if (resp) {
if (resp.data.is_pay_finish) {









this.$router.push({ name: 'payment-success', params: { order_id: this.query.order_id } });
} else {

if (+resp.code === 30902) {
this.bccPwdError = true;

} else {
let consume = resp.data.third_party_consume_param.consume;

if (resp.data.third_party_consume_param.service == '微信支付') {
if (consume.need_user_auth) {
window.location.href = consume.auth_url;
} else {
utils.wxPayment(consume.param)
.then(resp => {
if (resp) {
this.$router.push({ name: 'payment-success', params: { order_id: this.query.order_id } });
} else {
this.$vux.toast.show('支付失败');
}
});
}
} else {
utils.otherPayment(resp.data.third_party_consume_param.consume.form);
}
}

delete this.query.extra_param;  
}
}
this.$vux.loading.hide();
});
},

/** 获取通联支付卡号相关信息 */
onGetAllinCard(data) {
this.cardOptions = data;
},

/** 通联支付非空检测 */
checkCreditCardInput() {
const cardNum = this.cardOptions.cardNumber,
cardName = this.cardOptions.cardHolderName,
cardDate = this.cardOptions.cardExpireDate,
securityNum = this.cardOptions.securityNumber;

if (!cardNum || cardNum.length < 15) {
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_COMPLETE_CARD_NUM'));
return false;
}

if (!cardName) {
this.$vux.toast.show(this.$i18n.t('hotel.PLEASE_ENTER_HOLDER_NAME'));
return false;
}

if (!cardDate) {
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_EXPIRATION_DATE'));
return false;
}

if (!securityNum) {
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_SECURITY_CODE'));
return false;
}








return true;
},

/** 加密通联支付相关字段 */
encryptAllinParams() {
if (!this.checkCreditCardInput()) {
return false;
}

let cdNum = this.cardOptions.cardNumber.replace(/\s/g, ''),
month = this.cardOptions.cardExpireDate.split('/')[0],
year = this.cardOptions.cardExpireDate.split('/')[1],
encStrTemp = this.cardOptions.cardHolderName + '\n' + cdNum + '\n' + month + '\n' + year + '\n' + this.cardOptions.securityNumber,
md5StrTemp = this.cardOptions.cardHolderName + cdNum + month + year + this.cardOptions.securityNumber;

this.$vux.loading.show();
paymentProxy.getSecurityCode({ order_id: this.query.order_id })
.then(resp => {
if (resp) {
var securityData = resp.data;
var publicKey = securityData.public_key;	
var secretHash = {};
var encrypt = new JSEncrypt();

encStrTemp += '\nPASSWORD_AUTH\n' + securityData.timestamp + '\n' + securityData.secure_code + '\n' + this.query.bcc_pwd;
md5StrTemp += 'PASSWORD_AUTH' + securityData.timestamp + securityData.secure_code + this.query.bcc_pwd;

encrypt.setPublicKey(publicKey);	
secretHash.password_enc = encrypt.encrypt(encStrTemp);
secretHash.verify = hex_md5(md5StrTemp);
secretHash.secure_code = securityData.secure_code;

this.query.extra_param = {
secret: secretHash,
};
this.onSubmitPayment();
}
this.$vux.loading.hide();
});
},

getWalletInfo(){
let _this = this;
orderProxy.getUserWallet().then(resp=>{
if(resp.code==1){
let data = resp.data


_this.financeInfo = {
user_money:data.balance,
money_currency:localStorage.getItem('currency_code'),
bcc:{
bbc_balance:data.bcc.balance,

}
}
if(data.bcc.is_open_up){
_this.financeInfo.bcc.bbc_status = 1
}else{
_this.financeInfo.bcc.bbc_status = 0
}
this.getPaymentInfo();
}
})
},
setRootFontSize() {
var oHtml = document.documentElement;
var clientW = document.documentElement.clientWidth;
var winW = clientW > 440 ? 440 : clientW;
var fontSize = winW / 3.75 + 'px';

oHtml.style.fontSize = fontSize;
},
getBusinessCode() {
this.businessCode = 'HOTEL';
this.data.order_id = this.$route.query.order_id
this.detailUrl = ''
},
getRemainingText() {

const list = this.selectedMethods.filter(method =>
!['BALANCE', 'BCC'].includes(method)
)
if (list.length == 0) {
return this.$i18n.t('hotel.Pay_now')
}
let code = list[0]
for (const category of this.payList) {
if (category.list && Array.isArray(category.list)) {
for (const payment of category.list) {
if (code == 'LAKALA') {
return this.$i18n.t('hotel.PAY_TEXT14');
}
if (payment.code === code) {
return payment.pay_name ? payment.pay_name : this.$i18n.t('hotel.PAY_TEXT14');
}
}
}
}
return this.$i18n.t('hotel.Pay_now')
},
checkPay() {
if (this.selectedMethods.length == 0) {
return true
}
if (this.isExpired) {
return true
}
const hasBalance = this.selectedMethods.includes('BALANCE');
const hasBcc = this.selectedMethods.includes('BCC');
const hasOther = this.selectedMethods.some(method => !['BALANCE', 'BCC'].includes(method));
if (this.currentScenario === 1 && this.selectedMethods.length == 0) {
return true
}
if (this.currentScenario == 2) {
if ((hasBalance && Number(this.financeInfo.user_money) < this.orderAmount && !hasOther && !hasBcc) ||
(hasBcc && Number(this.financeInfo.bcc.bbc_balance) < this.orderAmount && !hasOther && !hasBalance)) {

return true;
}
}
if (this.currentScenario == 3) {

if (hasBalance && hasBcc && hasOther) {
console.log('余额+bcc+其他支付')
return false;
} else {
if (hasBalance && hasBcc && !hasOther) {
console.log('余额+bcc+没有其他支付')
if (this.orderAmount - Number(this.financeInfo.bcc.bbc_balance) - Number(this.financeInfo.user_money) > 0) {
return true;
} else {
return false
}
} else if ((hasBalance || hasBcc) && !hasOther) {
console.log('余额或者bcc+其他支付')
return true
}
}

}
if (this.currentScenario === 4 && this.selectedMethods.length == 0) {
return true;
}
return false
},
getRemainingPrice() {

if (this.currentScenario == 2) {
const hasBalance = this.selectedMethods.includes('BALANCE');
const hasBcc = this.selectedMethods.includes('BCC');
if (hasBalance) {
if (Number(this.financeInfo.user_money) > this.orderAmount) {
return 0
} else {
return Math.abs(this.orderAmount - Number(this.financeInfo.user_money)).toFixed(2)
}
}
if (hasBcc) {
if (Number(this.financeInfo.bcc.bbc_balance) > this.orderAmount) {
return 0
} else {
return Math.abs(this.orderAmount - Number(this.financeInfo.bcc.bbc_balance)).toFixed(2)
}

}
return this.orderAmount
}
if (this.currentScenario == 3) {

const hasBalance = this.selectedMethods.includes('BALANCE');
const hasBcc = this.selectedMethods.includes('BCC');
if (hasBalance && !hasBcc) {
return Math.abs(this.orderAmount - Number(this.financeInfo.user_money)).toFixed(2)
}
if (hasBcc && !hasBalance) {
return Math.abs(this.orderAmount - Number(this.financeInfo.bcc.bbc_balance)).toFixed(2)
}
if (hasBalance && hasBcc) {
if (this.orderAmount - Number(this.financeInfo.user_money) - Number(this.financeInfo.bcc.bbc_balance) > 0) {
return Math.abs(this.orderAmount - Number(this.financeInfo.user_money) - Number(this.financeInfo.bcc.bbc_balance)).toFixed(2)
} else {
return 0
}
}
}
return this.orderAmount
},
returnLAKALAFee() {
let price = this.getRemainingPrice()
let fee = price * (Number(this.LAKALAPAY) / 100)
return Math.ceil(fee)
},
isMethodSelected(methodId) {
return this.selectedMethods.includes(methodId);
},
hasLaKaLa() {
return this.selectedMethods.includes('LAKALA');
},
handleOpenMorePayMethod() {
this.isOpen = true
},
isMethodSelected(methodId) {
return this.selectedMethods.includes(methodId);
},
getMoneyAmount(currency, num) {
num = Number(num)
if (currency == 'VND' || currency == 'KRW' || currency == 'JPY') {
return Math.floor(num)
} else {
return num.toFixed(2)
}
},
getBalanceNumber() {
let num = 0
switch (this.currentScenario) {
case 1:
num = this.handleScenario1Price('BALANCE');
break;
case 2:
num = this.handleScenario2Price('BALANCE');
break;
case 3:
num = this.handleScenario3Price('BALANCE');
break;
}
return num;
},
getBCCNumber() {
let num = 0
switch (this.currentScenario) {
case 1:
num = this.handleScenario1Price('BCC');
break;
case 2:
num = this.handleScenario2Price('BCC');
break;
case 3:
num = this.handleScenario3Price('BCC');
break;
}
return num;
},
handleScenario1Price(methodId) {
if (methodId == 'BALANCE') {
return this.financeInfo.user_money - this.orderAmount
}
if (methodId == 'BCC') {
return this.financeInfo.bcc.bbc_balance - this.orderAmount
}
},
handleScenario2Price(methodId) {
if (methodId == 'BALANCE') {
if ((this.financeInfo.user_money - this.orderAmount) > 0) {
return this.financeInfo.user_money - this.orderAmount
}
return 0
}
if (methodId == 'BCC') {
if ((this.financeInfo.bcc.bbc_balance - this.orderAmount) > 0) {
return this.financeInfo.bcc.bbc_balance - this.orderAmount
}
return 0
}
},
handleScenario3Price(methodId) {
if (methodId == 'BALANCE') {
if ((this.financeInfo.user_money - this.orderAmount) > 0) {
return this.financeInfo.user_money - this.orderAmount
}
return 0
}
if (methodId == 'BCC') {
const hasBalance = this.selectedMethods.includes('BALANCE');
const hasBcc = this.selectedMethods.includes('BCC');
if (hasBalance && hasBcc) {
return (this.financeInfo.bcc.bbc_balance) - (this.orderAmount - Number(this.financeInfo.user_money)) < 0 ? 0 : (this.financeInfo.bcc.bbc_balance) - (this.orderAmount - Number(this.financeInfo.user_money))
} else if (!hasBalance && hasBcc) {
if ((Number(this.financeInfo.bcc.bbc_balance) - this.orderAmount) > 0) {
return this.orderAmount - Number(this.financeInfo.bcc.bbc_balance)
}
return 0
}

}
},
truncateString(str, length) {
if (str.length > length) {
return str.slice(0, length) + '...';
}
return str;
},
handleCloseDetailModal() {
this.isModalOrderDetailShow = false
this.isMaskShow = false
},
handleCloseMask(){
this.isModalOrderDetailShow = false
this.isMaskShow = false
this.isModal3DS = false
const filteredMethods = this.selectedMethods.filter(method => method !== 'ALLINPAY');
this.selectedMethods = filteredMethods
},
handleOpenDetailModal() {
this.isModalOrderDetailShow = true
this.isMaskShow = true
},
updateScenario() {
if (Number(this.financeInfo.user_money) == 0 && Number(this.financeInfo.bcc.bbc_status == 0 ? 0 : this.financeInfo.bcc.bbc_balance) == 0) {
this.currentScenario = 4;
} else if (Number(this.financeInfo.user_money) >= this.orderAmount && Number(this.financeInfo.bcc.bbc_balance) >= this.orderAmount) {
this.currentScenario = 1;
} else if ((Number(this.financeInfo.user_money) < this.orderAmount && Number(this.financeInfo.bcc.bbc_balance) >= this.orderAmount) ||
(Number(this.financeInfo.user_money) >= this.orderAmount && Number(this.financeInfo.bcc.bbc_balance) < this.orderAmount)) {
this.currentScenario = 2;
} else if (Number(this.financeInfo.user_money) < this.orderAmount && Number(this.financeInfo.bcc.bbc_balance) < this.orderAmount) {
this.currentScenario = 3;
}
},
handleMethodClick(methodId){
console.log(this.currentScenario)
if (this.isMethodDisabled(methodId)) {
return;
}
if (this.check1Disabled && methodId == 'BALANCE') {
return
}
if (this.check2Disabled && methodId == 'BCC') {
return
}
if (this.check3Disabled && methodId == 'WECHAT') {
return
}
if (this.check3Disabled && methodId == 'ALIPAY') {
return
}
if (this.check3Disabled && methodId == 'CHINAPAY') {
return
}
switch (this.currentScenario) {
case 1:
this.handleScenario1Click(methodId);
break;
case 2:
this.handleScenario2Click(methodId);
break;
case 3:
this.handleScenario3Click(methodId);
break;
case 4:
this.handleScenario4Click(methodId);
break;
}
},
handleScenario1Click(methodId) {
this.selectedMethods = [methodId];












if (methodId == 'ALLINPAY') {
this.isModal3DS = true
this.isMaskShow = true
}
},
handleScenario2Click(methodId) {
const isBaigaoMethod = methodId === 'BALANCE' || methodId === 'BCC';
console.log(78979)
if (isBaigaoMethod) {
const isSufficient = (methodId === 'BALANCE' && Number(this.financeInfo.user_money) >= this.orderAmount) ||
(methodId === 'BCC' && Number(this.financeInfo.bcc.bbc_balance) >= this.orderAmount);
console.log(isSufficient)
if (isSufficient) {
if(this.selectedMethods.length>0){
if(this.selectedMethods.includes(methodId)){

this.selectedMethods = [];
}else{

this.selectedMethods = [methodId];
}
}else{
this.selectedMethods = [methodId];
}
} else {
let list = this.selectedMethods.filter(m =>
m !== 'BALANCE' && m !== 'BCC'
);
let isLoad = this.selectedMethods.includes(methodId)
if(isLoad){
this.selectedMethods = list;
}else{
if (!list.includes(methodId)) {

list.push(methodId);
this.selectedMethods = list;
}
}

}
let list = this.selectedMethods.filter(m =>
m == 'BALANCE' || m == 'BCC'
);
if(list.length>0){
if(this.financeInfo.money_currency!='CNY'){
this.check3Disabled = true
}
}else{
if(this.financeInfo.money_currency!='CNY'){
this.check3Disabled = false
}
}
} else {
const hasSufficientBaigao = this.selectedMethods.some(m => {
if (m === 'BALANCE') return Number(this.financeInfo.user_money) >= this.orderAmount;
if (m === 'BCC') return Number(this.financeInfo.bcc.bbc_balance) >= this.orderAmount;
return false;
});
if (hasSufficientBaigao) {
this.selectedMethods = [methodId]
}
const hasInsufficientBaigao = this.selectedMethods.some(m => {
if (m === 'BALANCE') return Number(this.financeInfo.user_money) < this.orderAmount;
if (m === 'BCC') return Number(this.financeInfo.bcc.bbc_balance) < this.orderAmount;
return false;
});
console.log(hasInsufficientBaigao)
console.log('余额或bcc+其他支付')
if (hasInsufficientBaigao) {
if (this.selectedMethods.includes(methodId)) {
this.selectedMethods = this.selectedMethods.filter(m => m !== methodId);
} else {
const list = this.selectedMethods.filter(method =>
['BALANCE', 'BCC'].includes(method)
)
list.push(methodId)
this.selectedMethods = list;
}
} else {

this.selectedMethods = [methodId];
}
if (methodId == 'ALLINPAY') {
this.isModal3DS = true
this.isMaskShow = true
}
}
},
handleScenario3Click(methodId) {

const isBaigaoMethod = methodId === 'BALANCE' || methodId === 'BCC';
if (isBaigaoMethod) {


if (this.selectedMethods.includes(methodId)) {

this.selectedMethods = this.selectedMethods.filter(m => m !== methodId);
} else {


const list = this.selectedMethods.filter(method =>
['BALANCE', 'BCC'].includes(method)
)

list.push(methodId)
this.selectedMethods = list

}

let list = this.selectedMethods.filter(m =>
m == 'BALANCE' || m == 'BCC'
);
if(list.length>0){
if(this.financeInfo.money_currency!='CNY'){
this.check3Disabled = true
}
}else{
if(this.financeInfo.money_currency!='CNY'){
this.check3Disabled = false
}
}
}

else {
const hasBalance = this.selectedMethods.includes('BALANCE');
const hasBcc = this.selectedMethods.includes('BCC');
if (hasBalance && hasBcc) {

if (this.orderAmount - Number(this.financeInfo.user_money) - Number(this.financeInfo.bcc.bbc_balance) <= 0) {
return;
}
}



const otherMethods = ['WECHAT', 'ALIPAY', 'CHINAPAY', 'ALLINPAY', 'LAKALA'];
this.selectedMethods = this.selectedMethods.filter(m =>
!otherMethods.includes(m)
);


if (this.selectedMethods.includes(methodId)) {
this.selectedMethods = this.selectedMethods.filter(m => m !== methodId);
} else {
this.selectedMethods.push(methodId);
}
if (methodId == 'ALLINPAY') {
this.isModal3DS = true
this.isMaskShow = true
}
}
},
handleScenario4Click(methodId) {
const isBaigaoMethod = methodId === 'BALANCE' || methodId === 'BCC';
if (isBaigaoMethod) {
return; 
}
let list = this.selectedMethods.filter(m =>
m == 'BALANCE' || m == 'BCC'
);
if(list.length>0){
if(this.financeInfo.money_currency!='CNY'){
this.check3Disabled = true
}
}else{
if(this.financeInfo.money_currency!='CNY'){
this.check3Disabled = false
}
}
this.selectedMethods = [methodId];
if (methodId == 'ALLINPAY') {
this.isModal3DS = true
this.isMaskShow = true
}
},
isMethodDisabled(methodId) {
if (this.currentScenario === 4 && (methodId === 'BALANCE' || methodId === 'BCC')) {
return true;
}
return false;
},
handleCloseModal3DS(){
this.isModal3DS = false
this.isMaskShow = false
const filteredMethods = this.selectedMethods.filter(method => method !== 'ALLINPAY');
this.selectedMethods = filteredMethods
},
returnALLINPAYFee() {
let price = this.getRemainingPrice()
let fee = price * (Number(this.ALLINPAY) / 100)
return Math.ceil(fee)
},
handleInputCardNumber(e){
let card = e.target.value
let fcard = card.replace(/\s/g, '').replace(/[^\d]/g, '').replace(/(\d{4})(?=\d)/g, '$1 ');
this.fcardNum = fcard;
this.cardNum = fcard.replace(/\s/g, '');
if (card.length <= 4) {
this.iconName = this.getCardOrg(card)
}
},

getCardOrg(fcardNum) {
const cardNum = String(fcardNum).trim();
if (!cardNum) return null;


for (const item of this.regexpArr) {
const reg = new RegExp(item.regexp); 
if (reg.test(cardNum)) {
return item.name;
}
}

return null;
},

handleInputCardDate(e){
let date = e.target.value
let fdate = date.replace(/\//g, '');
let result = '';
if (date.length >= 2) {
result = fdate.substr(0, 2) + '/' + fdate.substr(2);
}
this.fcardDate = result
this.cardDate = result;
},
handlePayment(){
let _this = this;

if (this.isExpired) {
this.$vux.toast.show(this.$i18n.t('hotel.PAY_TEXT1'))

return
}
if (this.selectedMethods.length === 0) {
this.$vux.toast.show(this.$i18n.t('hotel.PAY_TEXT16'))
return
}
if ((this.selectedMethods.includes('WECHAT')||this.selectedMethods.includes('ALIPAY')||this.selectedMethods.includes('CHINAPAY'))&& this.orderDetail.currency_code != 'CNY') {
let price = this.orderDetail.cny_price
let title = `${this.$i18n.t('hotel.PAY_TEXT17')}${price}${this.$i18n.t('hotel.PAY_TEXT18')}`
this.$vux.confirm.show({
content: title,
confirmText: this.$i18n.t('hotel.OK'),
cancelText: this.$i18n.t('hotel.CANCEL'),
onConfirm() {
const hasBcc = _this.selectedMethods.includes('BCC');
if (hasBcc) {
_this.isShowBccPwdDialog = true
return;
}
_this.submitOrder()
}
});
}else{
const hasBcc = _this.selectedMethods.includes('BCC');
if (hasBcc) {
_this.isShowBccPwdDialog = true
return;
}
_this.submitOrder();
}
},
submitOrder(){
const hasBalance = this.selectedMethods.includes('BALANCE');
const hasBcc = this.selectedMethods.includes('BCC');
const hasALLINPAY = this.selectedMethods.includes('ALLINPAY');

let query = {
payment_method:this.returnPayMethod(),
payment_mode:this.returnPayMode(),
order_id:this.query.order_id,
use_balance:hasBalance?1:0,
use_bcc:hasBcc?1:0,
bcc_pwd:this.query.bcc_pwd,
extra_param:{},
code:this.query.code
}
if(hasALLINPAY){
query.extra_param = this.query.extra_param
}


paymentProxy.submitPayment(query).then(resp=>{
console.log(resp)
if(resp){
if(resp.data.is_pay_finish){
this.$router.push({name: 'payment-success', params: {order_id: this.query.order_id}});
}else{
if(+resp.code === 30902){
this.bccPwdError = true;
}else{
let consume = resp.data.third_party_consume_param.consume;
if(resp.data.third_party_consume_param.service_type == '1'){
if(consume.need_user_auth){
window.location.href = consume.auth_url;
}else{
utils.wxPayment(consume.param)
.then(resp => {
console.log('1111111'+resp)
if(resp){
this.$router.push({name: 'payment-success', params: {order_id: this.query.order_id}});
}else{
this.$vux.toast.show(this.$i18n.t('hotel.PAY_TEXT19'));
}
});
}
}else if(resp.data.third_party_consume_param.service_type == '12'){

window.location.href = consume;
return
}else if(resp.data.third_party_consume_param.service_type == '11'){

window.location.href = consume.pay_url;
return
}else if(resp.data.third_party_consume_param.service_type == '14'){

window.location.href = consume.pay_url;
return
}else{
utils.otherPayment(resp.data.third_party_consume_param.consume.form);
}
}
}
}
this.$vux.loading.hide();
})
},
handlePayTo3DS(){
let _this = this;
if (!this.check3DSData) {
return;
}
var cardOptions = {
cardNum: this.cardNum.replace(/\s/g, ''),
cardName: this.cardName,
cardDate: this.cardDate,
securityNum: this.securityNum,
}
console.log(cardOptions)

let cdNum = cardOptions.cardNum,
month = cardOptions.cardDate.split('/')[0],
year = cardOptions.cardDate.split('/')[1],
encStrTemp = cardOptions.cardName + '\n' + cdNum + '\n' + month + '\n' + year + '\n' + cardOptions.securityNum,
md5StrTemp = cardOptions.cardName + cdNum + month + year + cardOptions.securityNum;
this.$vux.loading.show();
paymentProxy.getSecurityCode({order_id: this.query.order_id}).then(resp=>{
if(resp){
var securityData = resp.data;
var publicKey = securityData.public_key;	
var secretHash = {};
var encrypt = new JSEncrypt();

encStrTemp += '\nPASSWORD_AUTH\n' + securityData.timestamp + '\n' + securityData.secure_code + '\n' + this.query.bcc_pwd;
md5StrTemp += 'PASSWORD_AUTH' + securityData.timestamp + securityData.secure_code + this.query.bcc_pwd;

encrypt.setPublicKey(publicKey);	
secretHash.password_enc = encrypt.encrypt(encStrTemp);
secretHash.verify = hex_md5(md5StrTemp);
secretHash.secure_code = securityData.secure_code;

this.query.extra_param = {
secret: secretHash,
};
this.submitOrder();
}
this.$vux.loading.hide();
})
},
check3DSData() {
let _this = this;
if (_this.cardNum == '') {
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_COMPLETE_CARD_NUM'));
return false;
}
if (_this.cardName == '') {
this.$vux.toast.show(this.$i18n.t('hotel.PLEASE_ENTER_HOLDER_NAME'));
return false;
}
if (_this.cardDate == '') {
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_EXPIRATION_DATE'));
return false;
}
if (_this.securityNum == '') {
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_SECURITY_CODE'));
return false;
}
},
returnPayMode(){





return 'WAP'












},
returnPayMethod(){
const pay_channel = {
'WECHAT': 1,
'ALIPAY': 2,
'CHINAPAY': 12,
'LAKALA': 11,
'ALLINPAY': 14,
}
const list = this.selectedMethods.filter(method =>
!['BALANCE', 'BCC'].includes(method)
)
let num = pay_channel[list[0]]
console.log(num)
if (utils.isWechatBrowser()) {
num =  1
}
return num?num:2;
},
getCardRegexp(){
new HotelProxy().getHotelConfig()
.then(resp => {
if(resp){
this.regexpArr = resp.data.regex;
}
});
},
getPayList(){
orderProxy.getPayListData({business_code:'HOTEL',client_id:3}).then(resp=>{
if(resp.code==1){
if (utils.isWechatBrowser()) {
this.payList = resp.data
}else{
let list = resp.data
list.forEach(group => {
if (group.type== 2) {

group.list = group.list.filter(item => item.code !== "WECHAT");
}
});
this.payList = list
}

}
})

},
getAgreement(){
orderProxy.getAgreementData({code:'baigolf_service_terms'}).then(resp=>{

if(resp.code==1){
this.contentHtml = resp.data;
}
})

},
handleOpenAgreement(){
this.isAgreeMentShow = true
},

startCountdown(remainingTime, formatType = 'minute') {
remainingTime = Number(remainingTime)
if(remainingTime<=0){

this.isExpired = true;
return
}
const padZero = num => num.toString().padStart(2, '0');
if (typeof remainingTime !== 'number' || remainingTime < 0) {

this.countdown = { hours: '', minutes: '00', seconds: '00' };
return () => {};
}
const validFormats = ['time', 'minute'];
if (!validFormats.includes(formatType)) {

formatType = 'time';
}
const updateCountdown = () => {
if (formatType === 'time') {

const hours = Math.floor(remainingTime / 3600);
const minutes = Math.floor((remainingTime % 3600) / 60);
const seconds = remainingTime % 60;
this.countdown = {
hours: padZero(hours),
minutes: padZero(minutes),
seconds: padZero(seconds)
};
} else {

const totalMinutes = Math.floor(remainingTime / 60);
const seconds = remainingTime % 60;
this.countdown = {
hours: '', // 分秒格式时清空小时字段
minutes: padZero(totalMinutes),
seconds: padZero(seconds)
};
}
};
updateCountdown();
if (this.countdownTimer) {
clearInterval(this.countdownTimer);
}
this.countdownTimer = setInterval(() => {
remainingTime--;
updateCountdown();

if (remainingTime <= 0) {
clearInterval(this.countdownTimer);
this.isExpired = true;
this.countdownTimer = null; 

}
}, 1000);
return () => {
clearInterval(this.countdownTimer);
this.countdownTimer = null;

};
},
returnImgICon(icon){
if(icon == 'JCB'){
return '/m/static/images/payment/jcb-card.png';
}else if(icon == 'VISA'){
return '/m/static/images/payment/visa.png';
}else if(icon == 'master'){
return '/m/static/images/payment/master.png';
}else if(icon == 'AMEX'){
return '/m/static/images/payment/wanshida.png';
}else{
return '/m/static/images/payment/default-card.png'
}

}
},
}



// WEBPACK FOOTER //
// ./src/views/payment/hotel-payment.vue